import React, { useState } from 'react';
import { Modal, Form, Button, Row, Col, ProgressBar } from 'react-bootstrap';

const NouveauVehicule = () => {
  const [show, setShow] = useState(true); // Modal affiché par défaut

  const handleClose = () => setShow(false);

  return (
    <div className="d-flex justify-content-center"> {/* Ajout de l'espace à gauche et à droite */}
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        fullscreen
        style={{ paddingLeft: '5rem', paddingRight: '5rem' }}
      >
        <Modal.Header closeButton>
          <Modal.Title className="w-100 text-center">Nouveau Véhicule</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: 'white' }}>
          <div className="container mt-3">
            {/* Barre de progression */}
            <Row className="mb-4 justify-content-center"> {/* Centrer la Row */}
  <Col md={6} className="text-center">
    <div>
      <ProgressBar now={50} label="Spécifications" variant="success" />
      <p>En cours</p>
    </div>
  </Col>
  <Col md={6} className="text-center">
    <div>
      <ProgressBar now={0} label="Détails" />
      <p>Suivant</p>
    </div>
  </Col>
</Row>
{/* Formulaire */}
            <Form>
              <h4>Ajouter l'immatriculation du véhicule</h4>
              <Row className="mb-3 justify-content-center"> {/* Centrer la Row */}
                <Col md={6}>
                  <Form.Group controlId="immatriculation">
                    <Form.Label>
                      N° immatricule <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control 
                      type="text" 
                      placeholder="Entrer le numéro d'immatriculation" 
                      size="sm"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <h4>Identification</h4>
              <Row className="mb-3 justify-content-center"> {/* Centrer la Row */}
                <Col md={6}>
                  <Form.Group controlId="nomVehicule">
                    <Form.Label>
                      Nom Véhicule <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control 
                      type="text" 
                      placeholder="Entrer le nom du véhicule" 
                      size="sm"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3 justify-content-center"> {/* Centrer la Row */}
                <Col md={6}>
                  <Form.Group controlId="type">
                    <Form.Label>
                      Type <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control 
                      type="text" 
                      placeholder="Entrer le type de véhicule" 
                      size="sm"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3 justify-content-center"> {/* Centrer la Row */}
                <Col md={6}>
                  <Form.Group controlId="statut">
                    <Form.Label>
                      Statut <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select size="sm">
                      <option>Choisir un statut</option>
                      <option>Disponible</option>
                      <option>En maintenance</option>
                      <option>Indisponible</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3 justify-content-center"> {/* Centrer la Row */}
                <Col md={6}>
                  <Form.Group controlId="marque">
                    <Form.Label>
                      Marque <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control 
                      type="text" 
                      placeholder="Entrer la marque du véhicule" 
                      size="sm"
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* Upload photo */}
              <Row className="mb-4 justify-content-center"> {/* Centrer la Row */}
                <Col md={6}>
                  <Form.Group controlId="photo">
                    <Form.Label>Photo de profil</Form.Label>
                    <div className="d-flex gap-2">
                      <Button variant="success" size="sm">Uploader</Button>
                      <Button variant="outline-success" size="sm">Glisser déposer</Button>
                    </div>
                  </Form.Group>
                </Col>
              </Row>

              {/* Bouton suivant */}
              <Row className="justify-content-center">
                <Col md={6} className="text-center">
                  <Button variant="primary" type="submit" size="sm">
                    Suivant
                  </Button>
                </Col>
              </Row>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default NouveauVehicule;
